<template>
  <b-card>
    <template #header>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fa fa-ellipsis-v mr-2 drag-handle"></i>
          <i class="icon-globe"></i> <strong>Last IPs</strong>
        </div>
        <b-button size="sm" variant="transparent" class="text-muted p-0" @click="$root.$emit('reset-grid-layout', 'ip-history-grid')" title="Reset Table Layout">
          <i class="fa fa-undo"></i>
        </b-button>
      </div>
    </template>
    <IPHistory
      v-if="hasPermission(UserIPsEmailView) && userData.ip_history"
      :records="userData.ip_history"
      :server="userData.server"
      :username="userData.username"
      :height="currentHeight"
    />
    <b-alert show variant="warning" class="text-center mb-0" v-else>
      You don't have the permission to see IPs!
    </b-alert>
    <div class="resize-handle" @mousedown.prevent="startResize">
      <i class="fa fa-ellipsis-h"></i>
    </div>
  </b-card>
</template>

<script>
import IPHistory from '../IPHistory'

export default {
  name: 'IPHistoryCard',
  components: {
    IPHistory
  },
  props: {
    userData: { type: Object, required: true },
    height: { type: Number, default: 500 }
  },
  data() {
    return {
      currentHeight: this.height,
      isResizing: false,
      startY: 0,
      startHeight: 0
    }
  },
  watch: {
    height(val) {
      this.currentHeight = val;
    }
  },
  methods: {
    startResize(e) {
      this.isResizing = true;
      this.startY = e.clientY;
      this.startHeight = this.currentHeight;
      document.addEventListener('mousemove', this.doResize);
      document.addEventListener('mouseup', this.stopResize);
    },
    doResize(e) {
      if (!this.isResizing) return;
      const diff = e.clientY - this.startY;
      const newHeight = Math.max(200, this.startHeight + diff); // Min height 200
      this.currentHeight = newHeight;
    },
    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.doResize);
      document.removeEventListener('mouseup', this.stopResize);
      this.$emit('update:height', this.currentHeight);
    }
  }
}
</script>

<style scoped>
.resize-handle {
  height: 15px;
  width: 100%;
  cursor: ns-resize;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #aaa;
  transition: background-color 0.2s;
}
.resize-handle:hover {
  background-color: rgba(32, 168, 216, 0.5);
  color: #fff;
}
</style>
